import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-return-supplier-invoice-list',
  templateUrl: './return-supplier-invoice-list.component.html',
  styleUrls: ['./return-supplier-invoice-list.component.css']
})
export class ReturnSupplierInvoiceListComponent implements OnInit {

  public menu_item_id = '58';
  public add_auth;
  public edit_auth;
  public del_auth;

  model = {
    'table_name': 'return_supplier_invoice', 'fromDate': new Date(), 'toDate': new Date(),
    'ret_supplier_invoice_no': '', 'branch_id': '0', 'title': 'قائمة المرتجعات'
  };

  private dp = [];
  displayedColumns = ['return_supplier_invoice_no', 'return_date', 'final_total', 'payment_method',
    'detail', 'print', 'edit']; // , 'del'
  displayedColumns2 = ['return_supplier_invoice_no', 'return_date', 'final_total', 'payment_method'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;
  private inv_list = [];
  from_date;
  to_date;

  branchList = [];

  Return_Inv_List; Success_Msg; Error_Msg; Del_Msg; From_Date; To_Date;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Return_Inv_List').subscribe((res: string) => {
      this.Return_Inv_List = res;
    });
    this.model['title'] = this.Return_Inv_List;


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

  }


  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });
  }

  search() {
    this.inv_list = [];
    this.dp = [];

    let field = "`return_supplier_invoice`.*"
    let from_table = "`return_supplier_invoice`"
    let condition = "";

    if (this.model['fromDate'] != undefined) {
      this.from_date = (this.model['fromDate'].getFullYear() + "-" + (this.model['fromDate'].getMonth() + 1) + "-" +
        this.model['fromDate'].getDate() + " 00:00:00");
      condition += " AND " + from_table + ".`return_date` >= '" + this.from_date + "'";
    }

    if (this.model['toDate'] != undefined) {
      this.to_date = (this.model['toDate'].getFullYear() + "-" + (this.model['toDate'].getMonth() + 1) + "-" +
        this.model['toDate'].getDate() + " 23:59:59");
      condition += " AND " + from_table + ".`return_date` <= '" + this.to_date + "'";
    }

    if (this.model['ret_supplier_invoice_no'] != '')
      condition = " AND " + from_table + ".`return_supplier_invoice_no` LIKE '%" +
        this.model['ret_supplier_invoice_no'] + "%' ";

    if (this.model['branch_id'] != '0')
      condition += " AND " + from_table + ".`branch_id` = '" + this.model['branch_id'] + "'";

    else if (this.model['branch_id'] == '0') {
      let index = 1;
      let list_length = this.branchList.length;

      condition += " AND " + from_table + ".`branch_id` IN (";
      this.branchList.forEach(element => {
        if (element.branch_id != '0') {
          if (index < list_length)
            condition += " '" + element.branch_id + "',";
          else if (index == list_length)
            condition += " '" + element.branch_id + "'";
        }
        index++;
      });
      condition += ")";
    }

    let query = "SELECT " + field + " FROM " + from_table + " WHERE `status` != '0'" + condition;
    let obj = { cmd: 'getList', query: query };
    // console.log(query);

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        let result = data.data['list'];
        let result3;

        result.forEach(element => {
          element.return_date = (element.return_date).substring(0, 10);
          element.payment_method = '';

          query = "SELECT `payment_type`.`payment_type_name` FROM `ret_supp_inv_payment_method`, `payment_type` WHERE `ret_supp_inv_payment_method`.`return_supplier_invoice_no` = '" +
            element.return_supplier_invoice_no + "' AND `ret_supp_inv_payment_method`.`payment_type_id` = `payment_type`.`payment_type_id`";
          obj = { cmd: 'getList', query: query };
          // console.log(query);
          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();

              result3 = data.data['list'];
              result3.forEach(element2 => {
                if (element.payment_method != '')
                  element.payment_method += ' - ';
                element.payment_method += element2.payment_type_name
              });
            });

          element.final_total = ((Number(element.total) - Number(element.discount)) + Number(element.tax)).toFixed(2);
        });
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  print(return_supplier_invoice_no = null) {
    let html_data = '';
    console.log(return_supplier_invoice_no);
    if (return_supplier_invoice_no == null) {
      html_data = '<table cellpadding="8" cellspacing="0"><tr>';
      html_data += '<td width="33%"> ' + this.From_Date + ': ' + this.from_date + '</td>';
      html_data += '<td width="33%"> ' + this.To_Date + ': ' + this.to_date + '</td>';
      html_data += '<td width="33%"> </td></tr>';
      html_data += '</table>';
      //html_data += '<tr><td width="33%"> رقم الفاتورة: ' + this.model['ret_invoice_no'] + ' </td>';
      // html_data += '<tr><td width="33%"> النوع: ';
      // this.typeList.forEach(element => {
      //   if (element.type_id == this.model['inv_type'])
      //     html_data += element.type_name;
      // });

      // html_data += '</td><td width="33%"> الحالة: ';
      // this.statusList.forEach(element => {
      //   if (element.status_id == this.model['inv_status'])
      //     html_data += element.status_name;
      // });
      let form = (document.getElementById('form1') as HTMLFormElement);
      let table = (document.getElementById('ret_inv_table2') as HTMLTableElement);
      html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
    }
    else
      window.open(this.applicationConstants.generatePDF + "?type=return_supplier_invoice&no=" + return_supplier_invoice_no, "_blank");
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }


  delRetInv(row) {
    if (confirm(this.Del_Msg)) {
      let values = [];
      values.push({ 'table_name': this.model['table_name'], 'return_supplier_invoice_no': row.return_supplier_invoice_no });
      values.push({ 'table_name': this.model['table_name'] + '_item', 'return_supplier_invoice_no': row.return_supplier_invoice_no });
      values.push({ 'table_name': 'ret_supp_inv_payment_method', 'return_supplier_invoice_no': row.return_supplier_invoice_no });

      let obj = { cmd: 'deleteRec', values: values };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          //console.log(data);
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

}
